export * from "@citizenm/foundation/shared/constants/date";

export const COOKIE_ID_TOKEN = "id_token";
export const DISCOUNTED_CAMPAIGN_BREAKFAST_CODE = "108";
export const PRIVATE_ROUTES = ["/get-booking", "/my/"];
export const MARRIOTT_REDIRECT_TIMEOUT = 2000; // in ms

/* Contentful entries */
export const CONTENTFUL_FOOTER_ID = "qbjrujxO6wKCBNt9wPDuD";
export const CONTENTFUL_NAVIGATION_ID = "BDioMqnQSecK7IPMswtk7";
export const BLOG_LANDING_PAGE_ID = "3SJTcdOjGHpBqXuLiCj70B";
export const LEGAL_LANDING_PAGE_ID = "33RUd173JlxG2ZGd1C3Zrp";
export const HOTEL_LANDING_PAGE_ID = "2DtOFXyUaWr6vYhO6W7yqo";

/* Booking Flow / Rates */
export const RATE_PLAN_CATEGORIES = { CAMPAIGN: "campaign" };
export const RATES_LIMITED_MAX_ROOMS_CATEGORIES = [
  "mycitizenmplus",
  "campaign",
];

/* Components */
export const MESSAGE_INFO_TYPE = {
  info: "info",
  success: "success",
  warning: "warning",
  error: "error",
  greyInfo: "grey-info",
  grey: "grey",
  location: "location",
  old: "old",
} as const;
